import { upcomingRenewalsList } from "constants/ReducerConstants/Constants";

const initialState = {
  upcomingRenewals: [],
};

export const UpcomingRenewalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case upcomingRenewalsList:
      return { ...state, upcomingRenewals: action.payload };
    default:
      return state;
  }
};
